import { z } from 'zod'

import { httpService } from '@/api/v1/http.service'
import { parsePaginated } from '@/utils/parse-paginated'
import { requiredString } from '@/utils/zod'

import type { InfiniteQueryOptions } from '../types/infinite-query'
import type { LabelAndValue } from '../types/label-and-value'
import { nextPageParamGetter } from '../utils/next-page-param-getter'

const parseSchema = z.object({
  id: requiredString(),
  name: requiredString()
})

export const coursesQueryOptions = (
  search?: string
): InfiniteQueryOptions<LabelAndValue> => ({
  queryKey: ['panelCurriculumCoursesList', search],
  staleTime: 60 * 100,
  queryFn: async ({ pageParam }) => {
    const response = await httpService.panel.panelCoursesList({
      search,
      page: pageParam,
      fetchKeys: {
        name: true,
        id: true
      }
    })

    return parsePaginated({
      schema: parseSchema,
      data: response,
      parse: item => ({
        label: item.name,
        value: item.id
      })
    })
  },

  getNextPageParam: nextPageParamGetter,
  initialPageParam: 1
})
